exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-progress{width:125px;height:125px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:1px dashed #ccc;.ep-legend--value:after{content:\"%\";display:inline-block}}.helper-text{display:block;margin-top:10px;font-style:italic;font-size:13px;color:#a7a7a7}", ""]);

// exports
